import React, { useEffect } from "react";
import {Label, Input, FormGroup, Button } from "reactstrap";


export default function HomeQA(props) {

  useEffect(() => {
   // console.log(props);
  }, []);



  return (
      <>
            {props.allQ && props.allQ.length > 0 ? (
            <div
              className={
                props.fstate.problemtype &&
                props.fstate.problemtype.problemtypeq &&
                props.fstate.problemtype.problemtypeq
                  ? "rectangleWarning"
                  : "rectangle"
              }
            >
              {props.curQ ? (
                <FormGroup>
                  <Label>Question:</Label>{" "}
                  <Input
                    type="input"
                    id="question"
                    disabled
                    value={props.curQ.Question}
                  ></Input>{" "}
                </FormGroup>
              ) : (
                ""
              )}

              {props.curA ? (
                <FormGroup>
                  <Label>Answer:</Label>
                  {props.curA.AnswerFormat !== "FREETEXT" &&
                  props.curA.AnswerFormat !== "DATE" &&
                  // props.curA.AnswerFormat !== "THISTEXT" &&
                  props.curAall ? (
                    <Input
                      type="select"
                      onChange={(e) => {
                        props.onSelectAnswer(e);
                      }}
                    >
                      {props.curAall.map((a) => (
                        <option key={a.AnswerId} value={a.AnswerId}>
                          {a.Answer}
                        </option>
                      ))}
                    </Input>
                  ) : (
                    ""
                  )}

                  {(props.curA.AnswerFormat === "FREETEXT" ) && props.curAall ? (
                    <Input
                      type="input"
                      autoComplete="on"
                      id={props.curA.AnswerId}
                      name={props.curA.AnswerId}
                      key={props.curA.AnswerId}
                      onChange={(e) => {
                        props.onSelectAnswer(e);
                      }}
                    />
                  ) : (
                    ""
                  )}

                  {props.curA.AnswerFormat === "DATE" && props.curAall ? (
                    <Input
                      type="date"
                      name="date"
                      id={props.curA.AnswerId}
                      placeholder=""
                      onChange={(e) => {
                        props.onSelectAnswer(e);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </FormGroup>
              ) : (
                ""
              )}

              {props.curA &&
              props.curA.TellCaller &&
              props.curA.TellCaller.length > 0 ? (
                
                <FormGroup>
                <span className="qa-label">{props.curA.TellCaller}</span>
               
                </FormGroup>
              ) : (
                ""
              )}
              {props.curA && props.curQ ? (
                <Button 
                  color="outline-info"
                  onClick={(e) => {
                    props.nextQA(e);
                  }}
                >
                  {props.translate(props.lang, "Next")}
                </Button>
              ) : (
                ""
              )}

              {!props.curQ &&
              !props.curA &&
              props.selectedQA &&
              props.selectedQA.length > 0
                ? props.selectedQA.map((a) => (
                    <FormGroup key={props.Guid()}>
                      <Label>
                        <span className="qa-label" key={props.Guid()}>
                          {props.translate(props.lang, "Question")}:
                        </span>
                      </Label>
                      <span className="qa-input" key={props.Guid()}>{a.Question}</span>
                      <p>
                        <Label>
                          <span className="qa-label" key={props.Guid()}>
                            {props.translate(props.lang, "Answers")}:
                          </span>
                        </Label>
                        <span className="qa-input" key={props.Guid()}>{a.Answer}</span>
                      </p>
                    </FormGroup>
                  ))
                : ""}
            </div>
          ) : (
            ""
          )}
    
    
   
      </>
  );
}
